import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-mist bg-grid-light py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-119" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-120" data-mp="9srxvkfpm86d">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-ivory rounded-md border border-line border-t-2 border-t-gold p-8 shadow-card sm:p-12" data-id="element-121" data-mp="etz6flpofbe3">
          <span className="inline-flex rounded-sm bg-petrolDark p-4 text-gold" data-id="element-122" data-mp="sldz6k9dyqyc">
            <ShieldCheckIcon className="h-10 w-10" data-id="element-123" data-mp="xivxlgps1ns3" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold uppercase text-ink" data-id="element-124" data-mp="12ja7l4axv7sr">Garantía de 7 días, sin preguntas</h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-125" data-mp="17j6cd5rgn39d">
            Abrís los tomos. Los usás en el aula, taller o laboratorio. Si en 7 días no es lo que esperabas, solicitás tu
            devolución.
          </p>
          <p className="mt-6 rounded-sm border-l-2 border-steel bg-steelSoft px-5 py-4 text-lg font-extrabold text-deep" data-id="element-126" data-mp="20r9a9ff938u7">
            Devolución del 100% sin formularios, sin drama.
          </p>
          <p className="mt-5 font-mono text-[11px] font-bold uppercase tracking-[.18em] text-muted" data-id="element-127" data-mp="1rtqils73pw9c">Tasa de devoluciones: menos del 1%</p>
        </motion.div>
      </div>
    </section>;
}